module.exports = __webpack_public_path__ + "img/Differentiation-BRCA_SpatialResearch.1a08dd79.png";